export {default as ServiceUtils} from './ServiceUtils.js';
export {default as Adr} from './adr/adr.js';
export {default as AdrEditService} from './adr/AdrEditService.js';
export {default as AdrConstants} from './adr/adrConstants.js';
export {default as AdrOptions} from './adr/adrOptions.js';
export {default as AdrService} from './adr/AdrService.js';
export {default as AssessmentService} from './firebase/assessmentService.js';
export {default as CampaignService} from './campaigns/campaignService';
export {default as Cart} from './cart/cart.js';
export {default as CartItem} from './cart/cartItem.js';
export {default as CartService} from './cart/cartService.js';
export {default as CartServices} from './cartService/cartService.js';
export {default as CartServiceAdaptor} from './ltocart/cartServiceAdaptor.js';
export {default as CartToShopCartAdaptor} from './ltocart/cartToShopCartAdaptor.js';
export {default as CheckoutApi} from './checkout/checkoutApi.js';
export {default as CurrencyCodes} from './currencyCodes.js';
export {default as CurrencyCodeToNumber} from './currencyCodeToNumber.js';
export {default as CurrencyService} from './currencyService.js';
export {default as ErrorMessageCookieService} from './error/errorMessageCookieService.js';
export {default as ErrorMessageList} from './error/errorMessageList.js';
export {default as ErrorMessage} from './error/errorMessage.js';
export {default as FavoritesService} from './favorites/FavoritesService';
export {default as LtoUtils} from './ltoUtils.js';
export {default as LuhnCheck} from './payment/luhnCheck.js';
export {default as newShop} from './newShop.js';
export {default as Order} from './order/order.js';
export {default as OrderAdapter} from './order/orderAdapter.js';
export {default as OrderManager} from './order/orderManager.js';
export {default as OrderService} from './order/orderService.js';
export {default as Payment} from './payment/Payment.js';
export {default as PaymentAdapter} from './payment/PaymentAdapter.js';
export {default as PaymentType} from './payment/paymentType.js';
export {default as PaymentService} from './payment/paymentService.js';
export {default as PaymentDto} from './payment/paymentDto.js';
export {default as PersonalOffer} from './PersonalOffer.js';
export {default as PersonalOfferService} from './personalOfferService.js';
export {default as PickupUtil} from './shipping/pickupUtil.js';
export {default as PointsCheckoutService} from './checkout/pointsCheckoutService.js';
export {default as ProcessorCode} from './payment/processorCodeEnum.js';
export {default as ProductContentService} from './product/ProductContentService.js';
export {ProductResultsEnum} from './product/productResultsEnum';
export {default as ProductService} from './cart/productService.js';
export {default as ProductStatusService} from './product/ProductStatusService.js';
export {default as ProductSearchService} from './product/productSearchService.js';
export {default as QualificationService} from './qualification/qualificationService.js';
export {default as SalesEventService} from './salesEventService.js';
export {default as SalesOrder} from './order/salesOrder.js';
export {default as ScanCard} from './adr/scanCard.js';
export {default as ScanCardService} from './adr/scanCardService.js';
export {default as ShippingAddress} from './shipping/ShippingAddress.js';
export {default as ShippingAddressAdapter} from './shipping/ShippingAddressAdapter.js';
export {default as ShippingService} from './shipping/ShippingService.js';
export {default as ShopContextService} from './shopContext.js';
export {default as ShopCartToCartAdaptor} from './ltocart/shopCartToCartAdaptor.js';
export {default as ShopServiceApiVersion} from './shopServiceApiVersion.js';
export {default as ShopStorage} from './shopStorage.js';
export {default as SolrQueryService} from './product/SolrQueryService.js';
export {default as TransBankPaymentAdapter} from './payment/transBankPaymentAdapter.js';
export {default as TransBankPaymentType} from './payment/transBankPaymentType.js';
export {default as CheckoutModeService} from './checkout/checkoutModeService';
export {default as OrderType} from './product/orderType.js';
export {default as StripePaymentService} from './StripePaymentService.js';
export {default as ExternalPaymentService} from './payment/externalPaymentService';
export {default as ExternalPaymentStatusEnum} from './payment/externalPaymentStatusEnum';
export {default as AccertifyFraudService} from './payment/accertifyFraudService.js';
export {default as EquinoxCartService} from './cart/equinoxCartService.js';
export {default as eidLogin} from './eidLogin';
export {default as Receiver} from './receiver';

export {PriceType, Agelocme, Product, ProductStatus} from '@nuskin/ns-product-lib';

import {nuskin} from '@nuskin/ns-util';
import './cart/persistentCartService';
import eidLogin from './eidLogin.js';
nuskin.eidLogin = eidLogin;

import pack from '../package.json';
import s from './nuskin.shop.js';
s.version = pack.version;
export const shop = s;

// load the contentStack configMaps that are used for ns-shop
import {getConfiguration} from '@nuskin/configuration-sdk';
import {events} from '@nuskin/ns-util';

const configMapsToLoad = ['Url', 'Basic', 'Shopping', 'ADP', 'Cart', 'Loyalty', 'Checkout', 'Equinox_Markets'];

const runConfigCallback = (runConfig) => {
    if (runConfig && typeof runConfig.clientId === 'string') {
        events.unsubscribe(events.global.RUN_CONFIG_CHANGED, runConfigCallback);
        getConfiguration(configMapsToLoad).then(() => console.log('ns-shop config loaded'));
    }
}

events.getValue(events.global.RUN_CONFIG_CHANGED, runConfigCallback, true);